import { Stack, Typography, useTheme } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import { ClientPaginatedTable } from 'components/table';
import * as TableConfig from './tablesConfig';
import { selectTranslations } from 'state/reducers/translation.reducers';
import React, { useEffect, useState } from 'react';
import { relationsTypes } from 'constants/customer-account.constants';
import { upsertCustomerRelations } from 'services/companies.service';
import { ButtonComponent } from 'components/ButtonComponent';

type IProps = {
	data: Record<string, any>[];
	type: relationsTypes;
	boUsers: Record<string, any>[];
};

export const ManageTable: React.FC<IProps> = ({ data, type, boUsers }: IProps) => {
	const t = useAppSelector(selectTranslations);
	const theme = useTheme();
	const dispatch = useAppDispatch();
	const [tableData, setTableData] = useState<Record<string, any>[]>([]);
	const tableButtonStyle = { minWidth: '135px', flexDirection: 'row-reverse' };
	const takenBoUserIds = tableData.filter((item) => item.boUserId !== null).map((item) => item.boUserId);

	useEffect(() => {
		setDefaultModifiedItems();
	}, [data]);

	const setDefaultModifiedItems = () => {
		const modifiedItems = data?.map((item: any) => {
			return { ...item, editable: false };
		});
		setTableData(modifiedItems || []);
	};

	const handleEditButtonClick = (countryId: number) => {
		const modifiedItems = data?.map((item: any) => {
			return { ...item, editable: countryId === item.id ? true : false };
		});
		setTableData(modifiedItems || []);
	};

	const saveItemChanges = (newItemData: any) => {
		const { id, name, active, boUserId } = newItemData;
		const userIdToSend = boUserId === '' ? null : boUserId;
		setDefaultModifiedItems();
		dispatch(upsertCustomerRelations({ id, name, active, type }, data, userIdToSend));
	};

	const cancelItemChanges = () => {
		setDefaultModifiedItems();
	};

	const updateModifiedItem = (field: any, fieldValue: any, changedItem: any) => {
		const modifiedItems = tableData?.map((item: any) => {
			return {
				...item,
				editable: changedItem.id === item.id ? true : false,
				name: changedItem.id === item.id ? (field === 'name' ? fieldValue : changedItem.name) : item.name,
				active:
					changedItem.id === item.id ? (field === 'active' ? fieldValue : changedItem.active) : item.active,
			};
		});
		setTableData(modifiedItems || []);
	};

	const updateBoUserItem = (field: any, fieldValue: any, changedItem: any) => {
		const modifiedItems = tableData?.map((item: any) => {
			return {
				...item,
				boUserId: changedItem.id === item.id ? fieldValue : changedItem.id,
			};
		});
		setTableData(modifiedItems || []);
	};

	return (
		<Stack spacing={2}>
			<Stack flexDirection={'row'} justifyContent={'space-between'}>
				<Typography variant="subtitle" color={theme.palette.root.grey}>
					{data?.length + ' ' + t('messages.results')}
				</Typography>
				<ButtonComponent
					disabled={false}
					handleClick={() => {
						setTableData([
							{
								id: null,
								name: 'xxx',
								active: false,
								editable: true,
							},
							...tableData,
						]);
					}}
					text={t('label.add')}
					icon={<img src="/icons/add.svg" style={{ marginLeft: '5px' }} />}
					styleObj={{ ...tableButtonStyle }}
				/>
			</Stack>
			{tableData && (
				<ClientPaginatedTable
					data={TableConfig.tableData(tableData)}
					columns={TableConfig.buildColumns(
						t,
						handleEditButtonClick,
						saveItemChanges,
						cancelItemChanges,
						updateModifiedItem,
						updateBoUserItem,
						type,
						boUsers,
						takenBoUserIds
					)}
				/>
			)}
		</Stack>
	);
};
